import CacheSettingsContainer from './CacheSettingsContainer'
import CacheSettings from './CacheSettings'
export { CacheSettings }
export { CacheSettingsContainer }
export default CacheSettingsContainer



// WEBPACK FOOTER //
// ./src/components/CacheSettings/index.js